export default __webpack_public_path__ + "5c129c30b0bb048146f7bb0e233357b0.png";